import { BrandingTheme, AppTheme } from 'styled-components';
import { brandingColourHeavy, brandingColourHeavyLight, brandingColourLight } from '../cssConstants';

// When editing this theme, please keep styled.d.ts up-to-date

export const personalTheme: BrandingTheme = {
	brandingColourHeavy,
	brandingColourLight
};

// App-specific theme used by all applications
export const appTheme: AppTheme = {
	primaryBackground: brandingColourHeavy,
	outlineColor: brandingColourHeavy,
	linkTextColor: brandingColourHeavy,
	cardButtonBackground: brandingColourHeavyLight,
	cardButtonRadius: '7px',
	cardButtonPadding: '2px 1px 2px 5px',
	cardButtonIconWidth: '18px',
	cardButtonIconHeight: '20px',
	fontFamily: "'Inter', sans-serif"
};

export const businessTheme: BrandingTheme = {
	brandingColourHeavy: '#F20000',
	brandingColourLight: 'rgba(255, 104, 118, 0.34)'
};

export const wealthTheme: BrandingTheme = {
	brandingColourHeavy: '#70747C',
	brandingColourLight: 'rgba(108, 108, 108, 0.35)'
};

export const estateTheme: BrandingTheme = {
	brandingColourHeavy: '#007A53',
	brandingColourLight: 'rgba(0, 111, 77, 0.34)'
};

export const healthTheme: BrandingTheme = {
	brandingColourHeavy: 'rgba(132, 47, 164, 1)',
	brandingColourLight: 'rgba(132, 47, 164, 0.5)'
};

export const developmentTheme: BrandingTheme = {
	brandingColourHeavy: 'rgba(253, 167, 0, 1)',
	brandingColourLight: 'rgba(253, 167, 0, 0.5)'
};
